<div class="modal-header border-0 pb-0">
  <h5 class="modal-title font-weight-bold text-dark">
    {{ modoSalvar ? (templateEmEdicao ? 'Editar Modelo' : 'Novo Modelo') : 'Modelos de Prescrição' }}
  </h5>
  <button type="button" class="close" aria-label="Close" (click)="activeModal.dismiss()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>

<div class="modal-body">

  <div *ngIf="!modoSalvar">
    
    <div class="d-flex justify-content-between align-items-center mb-4">
    
    <div class="search-box flex-grow-1 mr-2">
        <i class="fa fa-search"></i>
        <input type="text" class="form-control" placeholder="Pesquisar modelo..." [(ngModel)]="filtroPesquisa">
    </div>

    <button class="btn btn-success rounded-pill px-4" style="height: 40px; white-space: nowrap;" (click)="iniciarSalvamento()">
        <i class="fa fa-plus mr-1"></i> Criar Novo
    </button>
    
</div>

    <div class="template-list-container">
        
        <div *ngIf="loading" class="p-4 text-center text-muted">
            <i class="fa fa-spinner fa-spin fa-2x mb-2"></i><br>Carregando...
        </div>

        <div *ngIf="!loading && templatesFiltrados.length === 0" class="p-5 text-center text-muted">
            <i class="fa fa-folder-open-o fa-3x mb-3 text-light-gray"></i>
            <p>Nenhum modelo encontrado.</p>
        </div>

        <div *ngFor="let item of templatesFiltrados" class="template-item" (click)="usarTemplate(item)">
            <span class="template-title">
                <i class="fa fa-file-text-o mr-2 text-primary"></i> {{ item.titulo }}
            </span>
            
            <div class="template-actions">
                <button class="btn-icon btn-use" title="Usar este modelo">
                    <i class="fa fa-check"></i>
                </button>
                
                <button class="btn-icon btn-edit" (click)="$event.stopPropagation(); editarTemplate(item)" title="Editar">
                    <i class="fa fa-pencil"></i>
                </button>
                
                <button class="btn-icon btn-del" (click)="$event.stopPropagation(); excluirTemplate(item.id)" title="Excluir">
                    <i class="fa fa-trash"></i>
                </button>
            </div>
        </div>
    </div>
  </div>

  <div *ngIf="modoSalvar" class="editor-wrapper">
    <div class="form-group">
      <label class="font-weight-bold text-muted text-uppercase small">Título do Modelo</label>
      <input type="text" class="form-control form-control-lg" [(ngModel)]="novoTitulo" placeholder="Ex: Receita de Gripe...">
    </div>

    <div class="form-group mb-0">
      <label class="font-weight-bold text-muted text-uppercase small">Conteúdo</label>
      <div class="editor-visual" 
           contenteditable="true" 
           [innerHTML]="conteudoVisual" 
           (input)="atualizarConteudo($event)">
      </div>
      <small class="text-muted mt-2 d-block">
        <i class="fa fa-info-circle"></i> Edite o texto acima se necessário. A formatação original será preservada.
      </small>
    </div>
  </div>

</div>

<div class="modal-footer border-0 pt-0" *ngIf="modoSalvar">
  <button type="button" class="btn btn-light text-muted" (click)="modoSalvar = false">Cancelar</button>
  <button type="button" class="btn btn-primary px-4 rounded-pill shadow-sm" (click)="confirmarSalvamento()">
    <i class="fa fa-save mr-1"></i> {{ templateEmEdicao ? 'Atualizar Modelo' : 'Salvar Modelo' }}
  </button>
</div>